import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, vModelText as _vModelText, withDirectives as _withDirectives, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4eb7acaf"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card card-flush mt-6 mt-xl-9" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "card-header mt-5" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "d-flex align-items-center" }, [
    /*#__PURE__*/_createElementVNode("h3", { class: "fw-bolder mb-1" }, " Additional costs ")
  ])
], -1))
const _hoisted_3 = { class: "card-body" }
const _hoisted_4 = {
  key: 1,
  class: "table-responsive"
}
const _hoisted_5 = { class: "table table-row-bordered table-row-dashed gy-4 align-middle fw-bolder" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", { class: "fs-7 text-gray-400 text-uppercase" }, [
    /*#__PURE__*/_createElementVNode("th", null, "Name"),
    /*#__PURE__*/_createElementVNode("th", null, "Amount"),
    /*#__PURE__*/_createElementVNode("th")
  ])
], -1))
const _hoisted_7 = ["onUpdate:modelValue"]
const _hoisted_8 = ["onUpdate:modelValue"]
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, null, -1))
const _hoisted_10 = { colspan: "3" }
const _hoisted_11 = { class: "d-flex justify-content-center" }
const _hoisted_12 = { class: "svg-icon svg-icon-3 svg-icon-primary" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { class: "fs-4 ms-3" }, "Add new cost", -1))
const _hoisted_14 = { key: 0 }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("span", { class: "text-uppercase fs-4 fw-bold" }, " Totals: ")
], -1))
const _hoisted_16 = { colspan: "2" }
const _hoisted_17 = { class: "text-uppercase fs-4 fw-bold" }
const _hoisted_18 = { class: "d-flex justify-content-end mt-3" }
const _hoisted_19 = ["disabled"]
const _hoisted_20 = {
  key: 0,
  class: "spinner-border spinner-border-sm align-middle ms-2"
}
const _hoisted_21 = /*#__PURE__*/_createTextVNode(" Save costs ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LoadingSpinner = _resolveComponent("LoadingSpinner")!
  const _component_PlusSign = _resolveComponent("PlusSign")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      (_ctx.loading)
        ? (_openBlock(), _createBlock(_component_LoadingSpinner, { key: 0 }))
        : (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createElementVNode("table", _hoisted_5, [
              _hoisted_6,
              _createElementVNode("tbody", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.additionalCosts, (cost) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    key: cost.id
                  }, [
                    _createElementVNode("td", null, [
                      _createElementVNode("div", null, [
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": ($event: any) => ((cost.name) = $event),
                          class: "form-control h-30px w-100 w-md-75",
                          placeholder: "Enter name"
                        }, null, 8, _hoisted_7), [
                          [_vModelText, cost.name]
                        ])
                      ])
                    ]),
                    _createElementVNode("td", null, [
                      _createElementVNode("div", null, [
                        _withDirectives(_createElementVNode("input", {
                          type: "number",
                          "onUpdate:modelValue": ($event: any) => ((cost.amount) = $event),
                          class: "form-control h-30px w-100 w-md-50",
                          placeholder: "Enter amount"
                        }, null, 8, _hoisted_8), [
                          [_vModelText, cost.amount]
                        ])
                      ])
                    ]),
                    _hoisted_9
                  ]))
                }), 128)),
                _createElementVNode("tr", null, [
                  _createElementVNode("td", _hoisted_10, [
                    _createElementVNode("div", _hoisted_11, [
                      _createElementVNode("div", {
                        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.addNewCost && _ctx.addNewCost(...args))),
                        class: "cursor-pointer d-flex flex-row align-items-center"
                      }, [
                        _createElementVNode("span", _hoisted_12, [
                          _createVNode(_component_PlusSign)
                        ]),
                        _hoisted_13
                      ])
                    ])
                  ])
                ]),
                (_ctx.totals )
                  ? (_openBlock(), _createElementBlock("tr", _hoisted_14, [
                      _hoisted_15,
                      _createElementVNode("td", _hoisted_16, [
                        _createElementVNode("span", _hoisted_17, _toDisplayString(_ctx.totals), 1)
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ])
            ])
          ])),
      _createElementVNode("div", _hoisted_18, [
        _createElementVNode("button", {
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.handleSaveCosts && _ctx.handleSaveCosts(...args))),
          disabled: _ctx.isSaving,
          class: "btn btn-sm btn-success fs-6 fw-bold text-white"
        }, [
          (_ctx.isSaving)
            ? (_openBlock(), _createElementBlock("span", _hoisted_20))
            : _createCommentVNode("", true),
          _hoisted_21
        ], 8, _hoisted_19)
      ])
    ])
  ]))
}